import { render, staticRenderFns } from "./MainFooter.vue?vue&type=template&id=fc3431fc&scoped=true"
import script from "./MainFooter.vue?vue&type=script&lang=ts"
export * from "./MainFooter.vue?vue&type=script&lang=ts"
import style0 from "./MainFooter.vue?vue&type=style&index=0&id=fc3431fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3431fc",
  null
  
)

export default component.exports